import { useState } from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { FinanceFileFragment, FinanceInvoiceFileFragment } from 'generated/resources/graphql'

import { downloadBlob } from 'modules/core/lib/download'

import FileViewer from 'modules/documents/components/FileViewer'

import { DocumentRow } from './_DocumentRow'
import { EmptyBlock } from './_EmptyBlock'

interface SaleInvoiceDocumentsProps {
  files: (FinanceFileFragment | FinanceInvoiceFileFragment)[]
}

const SaleInvoiceDocuments = ({ files }: SaleInvoiceDocumentsProps) => {
  const [selectedFile, setSelectedFile] = useState<
    FinanceFileFragment | FinanceInvoiceFileFragment | null
  >(files[0] ?? null)

  const downloadFileFromUrl = async (url: string, fileName: string) => {
    const response = await fetch(url)

    if (!response.ok) {
      return
    }

    const blob = await response.blob()
    downloadBlob(blob, fileName)
  }

  if (files.length === 0) return <EmptyBlock />

  return (
    <Box padding="s24" flexDirection="row" gap="s12">
      <Box width="full">
        <Table fullWidth style={{ overflowY: 'auto', height: 'auto' }} autoLayout>
          <Table.Body>
            {files.map((file) => (
              <DocumentRow
                key={file.id}
                file={file}
                onClick={(file) => setSelectedFile(file)}
                onDownload={downloadFileFromUrl}
                selected={selectedFile?.id === file.id}
              />
            ))}
          </Table.Body>
        </Table>
      </Box>
      <Box
        width="full"
        border={selectedFile ? { all: { style: 'solid', width: 's1', color: 'grey400' } } : false}
      >
        {selectedFile && (
          <FileViewer
            url={selectedFile.url}
            filename={selectedFile.filename}
            mimeType={selectedFile.contentType}
            isUrlAbsolute
          />
        )}
      </Box>
    </Box>
  )
}

export default SaleInvoiceDocuments
